import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { AppName } from "../../../../util/app";
import DropdownList from "../../../Patient/partial/DropdownList";
import DatePicker from "react-datepicker";
import FabButton from "../../../../partials/Buttons/FabButton";
import Editor from "../../../../partials/Editor";

const InsertManyNote = ({ onCancel, onSubmit, categories }) => {
    const [model, setModel] = useState({ notes: [{ note: "", summary: "", category: "", datetime: new Date() }], confirm: false });

    const onChange = (idx, key, value) => {
        if (key && value) {
            let _model = { ...model };
            _model.notes[idx][key] = value;
            setModel(_model);
        }
    };

    return (
        <>
            <Helmet>
                <title>New Care note | {AppName}</title>
            </Helmet>
            <form
                onSubmit={(evt) => {
                    evt.preventDefault();
                    onSubmit(model);
                }}
            >
                <div className="row">
                    <div className="col-12">
                        <button onClick={onCancel} title="Back" className="mdl-button mdl-js-button mdl-button--default margin-left-10">
                            <i className="material-icons text-primary">keyboard_backspace</i> Back
                        </button>
                    </div>
                    {model.notes.map((item, idx) => (
                        <div className="col-12 fade-in" key={idx}>
                            <div className="card">
                                <div className="card-head">
                                    <header>New Care Note: #{idx + 1}</header>
                                </div>
                                <div className="card-body">
                                    <div className="form-row">
                                        <div className="col">
                                            <DropdownList onSelect={(item) => onChange(idx, "category", item.id)} items={categories} title="Category" />
                                        </div>
                                        <div className="col">
                                            <label htmlFor={"datetime-id" + idx}>Datetime</label>
                                            <DatePicker
                                                id={"datetime-id" + idx}
                                                selected={model.notes[idx].datetime}
                                                onChange={(date) => onChange(idx, "datetime", date)}
                                                className="form-control input-height"
                                                timeIntervals={15}
                                                dateFormat="MMMM d, yyyy"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor={"summary-id" + idx}>Summary</label>
                                        <input
                                            type="text"
                                            className="form-control input-height"
                                            onChange={({ currentTarget }) => onChange(idx, "summary", currentTarget.value)}
                                            id={"summary-id" + idx}
                                            required
                                            aria-describedby="summary-id"
                                            placeholder="enter summary"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor={"note" + idx}>Note</label>
                                        <Editor height={250} placeholder="Enter note here .." onChange={(_note) => onChange(idx, "note", _note)} />

                                        <small className="form-text text-muted">Clinical Note/Plan Note</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <div className="custom-control custom-checkbox">
                                        <input type="checkbox" onChange={(event) => setModel({ ...model, confirm: event.target.checked })} className="custom-control-input" id="customCheck1" />
                                        <label className="custom-control-label" htmlFor="customCheck1">
                                            Confirm note upon saving
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="text-center">
                            <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default">
                                <i className="material-icons text-danger">cancel</i> Cancel
                            </button>

                            <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-success">
                                Save Notes <i className="material-icons">arrow_right_alt</i>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            <FabButton
                title="Add More Note"
                onClick={() => {
                    let _model = { ...model };
                    _model.notes.push({ note: "", summary: "", category: "", datetime: new Date() });
                    setModel(_model);
                }}
            />
        </>
    );
};

export default InsertManyNote;
